import { getVariationAttributeFromProduct } from '../../common/helpers/productModelHelpers';
import { addSizeToVariationGroupId } from '../../common/helpers/productIdHelpers';

export const productSizesMixin = {
  computed: {
    isSelectedSize() {
      const lastSelectedSize = this.getLastSelectedSize();
      return lastSelectedSize?.displayValue
        && lastSelectedSize?.value;
    },
    sizeResetUrl() {
      return this.sizeAttr?.resetUrl;
    },
    sizeAttr() {
      return getVariationAttributeFromProduct(
        this.product,
        'size',
      );
    },
    /**
     * Get the product size variant attribute values
     * @returns {Array} size values
     */
    sizes() {
      if (this.sizeAttr) {
        return this.sizeAttr.values;
      }
      return [];
    },
  },

  methods: {
    hasUniqueSelectableSize() {
      return this.hasUniqueSize() && this.sizes[0].selectable;
    },
    hasUniqueUnselectableSize() {
      return this.hasUniqueSize() && !this.sizes[0].selectable;
    },
    hasSomeSelectableSize() {
      return this.sizes.some((size) => size.selectable);
    },
    hasUniqueSize() {
      return this.sizes.length === 1;
    },
    getUniqueSize() {
      return this.sizes[0];
    },
    getUniqueSizeVariantPid() {
      if (this.hasUniqueSize()) {
        return addSizeToVariationGroupId(this.product.id, this.sizes[0].id);
      }
      return '';
    },
    getSelectableSizesSum() {
      let count = 0;
      for (let i = 0; i < this.sizes.length; i++) {
        const size = this.sizes[i];
        if (size.selectable) count += 1;
      }
      return count;
    },
    getSizeWithValue(value) {
      return this.sizes.find((size) => size.value === value);
    },
    getLastSelectedSize() {
      return this.selectedSize?.displayValue
        ? this.selectedSize
        : this.sizes.find((size) => size.selected === true);
    },
  },
};

export default {
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    selectedSize: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  ...productSizesMixin,
};
